import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';

export const getClubEvents = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/club-events', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const getClubEvent = async (id, callback) => {
     try {
        const response = await risapi.get(`/api/club-events/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const createClubEvent = async (data, callback) => {
    try {
        const response = await risapi.post('/api/club-events', data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error.response.data); // Return validation errors
    }
};

export const updateClubEvent = async (id, data, callback) => {
    try {
        const response = await risapi.put(`/api/club-events/${id}`, data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error.response.data); // Return validation errors
    }
};

export const deleteClubEvent = async (id, callback) => {
    try {
        await risapi.delete(`/api/club-events/${id}`, getAxiosConfig());
        callback({ success: true });
    } catch (error) {
        callback(error);
    }
};

// --- Member Management ---

export const addClubEventMember = async (eventId, userId, callback) => {
    try {
        const response = await risapi.post(`/api/club-events/${eventId}/members`, { user_id: userId }, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const removeClubEventMember = async (eventId, userId, callback) => {
    try {
        const response = await risapi.delete(`/api/club-events/${eventId}/members/${userId}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};